<!-- 处理 el-menu-item 样式 -->
<template>
  <!-- <i v-if="icon.includes('el-icon')" class="sub-el-icon" :class="icon"></i> -->
  <svg-icon :icon="icon" v-if="props.icon"></svg-icon>
  <span>{{ generateTitle(title) }}</span>
</template>

<script setup>
import { generateTitle } from '@/utils/i18n'
import { defineProps } from 'vue'

const props = defineProps({
  title: {
    type: String,
    require: true
  },
  icon: {
    type: String,
    require: true
  }
})
</script>

<style lang='scss' scoped>
</style>
